"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMoney = exports.Money = exports.SYMBOL_FORMAT_DECIMAL = exports.SYMBOL_FORMAT_INT = void 0;
var money_symbols_1 = require("./money.symbols");
var money_adapter_1 = require("./money.adapter");
exports.SYMBOL_FORMAT_INT = '[[FormatInt]]';
exports.SYMBOL_FORMAT_DECIMAL = '[[FormatDecimal]]';
var Money = /** @class */ (function () {
    function Money(amount, currency, decimals) {
        this.amount = amount || 0;
        this.currency = currency;
        this.symbol = money_symbols_1.MONEY_SYMBOLS[currency] || currency;
        this.decimals = decimals;
    }
    Money.create = function (data) {
        var _a = money_adapter_1.Adapter.params(data), amount = _a[0], currency = _a[1], decimal = _a[2];
        return new Money(amount, currency, decimal);
    };
    Money.prototype.formatIntl = function (locale, options) {
        if (locale === void 0) { locale = navigator.language; }
        if (options === void 0) { options = {}; }
        try {
            return new Intl.NumberFormat(locale, __assign(__assign({}, options), { style: 'currency', currency: this.currency })).format(this.formatAmount());
        }
        catch (e) {
            return this.formatAmountWithSymbol();
        }
    };
    /**
     * Get amount with currency -> 150000/EUR|2
     */
    Money.prototype.formatToRawString = function () {
        return "".concat(this.amount, "|").concat(this.currency, "|").concat(this.decimals);
    };
    /**
     * Get amount without symbol and comma separation -> 1500.00
     */
    Money.prototype.formatAmount = function () {
        return this.amount / Math.pow(10, this.decimals);
    };
    /**
     * Get with symbol and comma separation -> € 1,500.00
     */
    Money.prototype.formatAmountWithSymbol = function () {
        var value = this.formatToParts();
        return "".concat(this.symbol, " ").concat(value.string.integer, ".").concat(value.string.decimal);
    };
    /**
     * Split amount in integer and normalizeDecimals values
     */
    Money.prototype.formatToParts = function () {
        var _a = this.formatAmount().toFixed(this.decimals).split('.'), int = _a[0], decimal = _a[1];
        return {
            number: { integer: +int, decimal: +decimal },
            string: { integer: this[exports.SYMBOL_FORMAT_INT](int, ','), decimal: this[exports.SYMBOL_FORMAT_DECIMAL](decimal) }
        };
    };
    /**
     * Sum two Money
     */
    Money.prototype.sum = function (instanceToSum) {
        this.throwErrorForSumAndSub(instanceToSum);
        return Money.create({
            amount: this.amount + instanceToSum.amount,
            currency: this.currency,
            decimals: this.decimals
        });
    };
    /**
     * Multiply a Money by a number
     */
    Money.prototype.multiply = function (multiplier) {
        return Money.create(__assign(__assign({}, this), { amount: this.amount * multiplier }));
    };
    /**
     * Divide a Money by a number
     */
    Money.prototype.divide = function (divisor) {
        this.throwErrorDivideByZero(divisor);
        return Money.create(__assign(__assign({}, this), { amount: this.amount / divisor }));
    };
    /**
     * Subtraction two Money
     */
    Money.prototype.sub = function (instanceToSub) {
        this.throwErrorForSumAndSub(instanceToSub);
        return Money.create({
            amount: this.amount - instanceToSub.amount,
            currency: this.currency,
            decimals: this.decimals
        });
    };
    Money.prototype[exports.SYMBOL_FORMAT_INT] = function (value, separator) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    };
    Money.prototype[exports.SYMBOL_FORMAT_DECIMAL] = function (value) {
        if (!value) {
            return '0'.repeat(this.decimals);
        }
        return value.length < this.decimals ? "".concat(value).concat('0'.repeat(this.decimals - value.length)) : value;
    };
    Money.prototype.throwErrorForSumAndSub = function (instancePassed) {
        if (instancePassed.currency !== this.currency) {
            throw new Error("Currencies are different: received ".concat(instancePassed.currency, ", expected ").concat(this.currency));
        }
        if (instancePassed.decimals !== this.decimals) {
            throw new Error("Decimals are different: received ".concat(instancePassed.decimals, ", expected ").concat(this.decimals));
        }
    };
    Money.prototype.throwErrorDivideByZero = function (divisor) {
        if (divisor === 0) {
            throw new Error('Impossible to divide by zero');
        }
    };
    return Money;
}());
exports.Money = Money;
function createMoney(data) {
    return Money.create(data);
}
exports.createMoney = createMoney;
